module.exports = __webpack_public_path__ + "assets/img/yinxingfeipang--blue.4c60708f.png";